import { render, staticRenderFns } from "./PageButtonForm.vue?vue&type=template&id=1107ee2c&scoped=true"
import script from "./PageButtonForm.vue?vue&type=script&lang=js"
export * from "./PageButtonForm.vue?vue&type=script&lang=js"
import style0 from "./PageButtonForm.vue?vue&type=style&index=0&id=1107ee2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1107ee2c",
  null
  
)

export default component.exports